module.exports = __webpack_public_path__ + "static/media/commission-report-icon.929637ef.svg";